import { ConfirmPopup, Text } from '~/commonComponents';
import WarningIcon from '~/images/icons/Warning';
import { Colors } from '~/themes/colors';

const WarningIconComponent = () => (
  <WarningIcon width={80} height={80} color={Colors.primary_500} />
);

interface IRejectCandidateConfirmationPopupProps {
  isLoading: boolean;
  jobLocalDate: string;
  professionalName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeclineCandidateConfirmationPopup = ({
  isLoading,
  jobLocalDate,
  professionalName,
  onClose,
  onConfirm,
}: IRejectCandidateConfirmationPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    Icon={WarningIconComponent}
    title="Before You Continue"
    titleStyle={{ marginTop: 21, marginBottom: 20 }}
    description={
      <Text color={Colors.neutral_500}>
        Are you sure you want to decline <Text color={Colors.neutral_500}>{professionalName}</Text>{' '}
        <br />
        for the interview on {jobLocalDate}?
        <br />
        If yes, click “Decline” to continue.
      </Text>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    leftButtonAction={onClose}
    leftButtonDisabled={isLoading}
    leftButtonText="Go Back"
    rightButtonAction={onConfirm}
    rightButtonLoading={isLoading}
    rightButtonText="Yes, Decline"
  />
);
